import lang from 'lang.js';
import messages from './messages';
// Import modular translations
import enTranslations from './en';
import arKwTranslations from './ar_kw';
import arSaTranslations from './ar_sa';

const allMessages = {
    ...messages,
    ...enTranslations,
    ...arKwTranslations,
    ...arSaTranslations,
};

const savedLocale = localStorage.getItem('locale') || 'ar_kw';

const Lang = new lang({
    messages: allMessages,
    locale: savedLocale,
    fallback: 'ar_kw'
});

export default Lang;